import { watchlistReducer } from '@/components/Watchlist/watchlistSlice';
import { benchmarkReducer } from '@/features/api/benchmarkSlice';
import navigationReducer from '@/features/api/navigationSlice';
import { graphPreferencesReducer } from '@/features/api/preferences/graphSlice';
import { notificationPreferencesReducer } from '@/features/api/preferences/notificationPopupSlice';
import { tablePreferencesReducer } from '@/features/api/preferences/tableSlice';
import { valuationPreferencesReducer } from '@/features/api/preferences/valuationSlice';
import { variationPreferencesReducer } from '@/features/api/preferences/variationSlice';
import { viewPreferencesReducer } from '@/features/api/preferences/viewSlice';
import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import apiWrapper from '../features/api';
import { usersReducer } from '../features/api/apiSlice';
import { notificationsReducer } from '../features/api/notificationSlice';
import { screenerPresetReducer } from '../features/api/screener/presetSlice';
import { screenerReducer } from '../features/api/screener/slice';
import enterpriseReducer from '../features/keto/ketoSlice';
import kratosApi from '../features/kratos';
import kratosReducer from '../features/kratos/kratosSlice';
import piaApi from '../features/pia/piaApi';

const combinedReducers = combineReducers({
  kratos: kratosReducer,
  enterprise: enterpriseReducer,
  users: usersReducer,
  screener: screenerReducer,
  screenerPreset: screenerPresetReducer,
  notifications: notificationsReducer,
  notification_preferences: notificationPreferencesReducer,
  table_preferences: tablePreferencesReducer,
  graph_preferences: graphPreferencesReducer,
  variation_preferences: variationPreferencesReducer,
  valuation_preferences: valuationPreferencesReducer,
  view_preferences: viewPreferencesReducer,
  navigation: navigationReducer,
  watchlist: watchlistReducer,
  benchmark: benchmarkReducer,
  [piaApi.reducerPath]: piaApi.reducer,
  [apiWrapper.reducerPath]: apiWrapper.reducer,
  [kratosApi.reducerPath]: kratosApi.reducer,
});

export type InitialState = ReturnType<typeof combinedReducers>;

export const store = configureStore({
  reducer: (state: InitialState | undefined, action) => {
    if (action.type === 'logout') {
      state = undefined;
    }
    return combinedReducers(state, action);
  },
  middleware: (getDefault) =>
    getDefault()
      .concat(apiWrapper.middleware)
      .concat(kratosApi.middleware)
      .concat(piaApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
